import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const useAnalytics = (page, { slug, postId } = {}) => {
  useEffect(() => {
    const params = new URLSearchParams({ page });
    if (slug) params.append('slug', slug);
    if (postId) params.append('post_id', postId);

    axios.post(`${API}/analytics/track?${params.toString()}`).catch(() => {});
  }, [page, slug, postId]);
};

export default useAnalytics;
